import { render, staticRenderFns } from "./take-out-order.vue?vue&type=template&id=53f4da3a&scoped=true"
import script from "./take-out-order.vue?vue&type=script&lang=js"
export * from "./take-out-order.vue?vue&type=script&lang=js"
import style0 from "./take-out-order.vue?vue&type=style&index=0&id=53f4da3a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f4da3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f4da3a')) {
      api.createRecord('53f4da3a', component.options)
    } else {
      api.reload('53f4da3a', component.options)
    }
    module.hot.accept("./take-out-order.vue?vue&type=template&id=53f4da3a&scoped=true", function () {
      api.rerender('53f4da3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/take-out-order.vue"
export default component.exports